import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Label, ActionButton, DownloadFileLink } from 'fw/components';
import { SetupTab } from 'areas/shared/pages/setup';
import * as App from 'modules/app/App'
import * as API from 'modules/app/API'
import * as Formatting from 'fw/misc/Formatting';
import { CompanyInfoTabHelpers } from 'areas/shared/helpers';

class CompanyInfoTab extends SetupTab {
    urls() {
        return {
            get: API.Sponsor.url('/sponsorSetup/getVobInfo'),
        }
    }

    getRequest(selectedId) {
        return {
            certificationId: this.props.selectedId
        }
    }

    privileges() {
        return {
            edit: App.hasPrivilege("ConnectToVOBEdit")
        }
    }

    ready = () => {
        this.focusControl && this.focusControl.focus();
    }

    renderForm() {
		const form = this.state.form;

        let labelClass = "label label-default";
        if (form.certificationStatus === 'Certified')
            labelClass = "label label-success";
        else if (form.certificationStatus === 'Expired')
            labelClass = "label label-danger";

        return (
            <React.Fragment>
                <Row>
                    <Col md={12}>
                        <h3 className="inline">
                            {form.name} &nbsp;
                            <small>
                                {form.location}&nbsp;&nbsp;<span className={labelClass}>{form.certificationStatus}</span>
                            </small> 
                        </h3>
                        <span className="pull-right" style={{textAlign:"right", marginTop: "5px" }}>
                            <ActionButton id='btnViewCertificate' onClick={() => CompanyInfoTabHelpers.downloadFile(form.certificateStorageToken, form.certificateFileName)} icon='save'>
                                View Company Certificate
                            </ActionButton>
                        </span>
                        <div style={{ marginTop: "5px" }}>
                            Doing Business As: <b>{form.dba ? form.dbaNames : " - "}</b>
                            <br />
                            Initial Cert Date: <b>{form.initialCertificationDate ? Formatting.formatDate(form.initialCertificationDate) : " - "}</b>
                        </div>
                        <br /><hr />
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <Label>Capabilities Statement:</Label>
                        <p>{form.productDescription}</p>
                    </Col>                    
                </Row>
                <Row>
                    <Col md={12}>
                        <Label>Professional Accreditation:</Label>
                        <p>{form.professionalAccreditation}</p>
                    </Col>                   
                </Row>
                <Row>
                    <Col md={6}><p><Label>NAICS Codes:</Label> {form.naicsCodes}</p></Col>
                    <Col md={6}>
                        <Label>Capabilities Upload:</Label>&nbsp;
                        <DownloadFileLink
                            storageToken={form.capabilitiesStatementStorageToken}
                            fileName={form.capabilitiesStatementFileName}
                            buttonName={form.capabilitiesStatementFileName}
                            buttonStyle="link"
                            wrapFileNameLength={55}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col md={6}><p><Label>NAICS Description:</Label> {form.naicsDescription}</p></Col>
                    <Col md={6}>
                        <Row>
                            <Col md={12}>
                                <Label>Professional Accreditation Upload:</Label>&nbsp;
                                <DownloadFileLink
                                    storageToken={form.professionalAccreditationStorageToken}
                                    fileName={form.professionalAccreditationFileName}
                                    buttonName={form.professionalAccreditationFileName}
                                    buttonStyle="link"
                                    wrapFileNameLength={40}
                                />
                            </Col>
                        </Row>
                        {CompanyInfoTabHelpers.renderCertifications(form)}
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <p><Label>Geographic Market:</Label> {form.geoMarket}</p>
                        <p><Label>Number of Full Time Employees:</Label> {form.employees}</p>
                        <p><Label>Service Disabled Veteran:</Label> {form.disabled}</p>
                    </Col>
                    <Col md={6}>
                        <p><Label>Website URL:</Label> {Formatting.externalLink(form.website)}</p>
                        <Label>Company Phone(s):</Label>
                        <br />
                        {CompanyInfoTabHelpers.renderPhones(form.vobPhones)}
                        <Label>Primary Contact Information:</Label> <br />
                        {form.primaryContact} - {form.primaryContactTitle}<br />
                        {CompanyInfoTabHelpers.renderPhones(form.veteranOwnerPhones)}
                        <br />
                        <a href={`mailto:${form.primaryContactEmail}`}>{form.primaryContactEmail}</a>
                    </Col>
                </Row>
            </React.Fragment>
        )
    }
}

export default CompanyInfoTab;



// WEBPACK FOOTER //
// ./src/areas/sponsor/connectToVOB/CompanyInfoTab.js